import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ActiveEventContext } from "@/context/ActiveEventContext";
import { applyBrandColor } from "@/lib/theme";
import Home from "@/pages/Home";
import CheckIn from "@/pages/CheckIn";
import CheckOut from "@/pages/CheckOut";
import Admin from "@/pages/Admin";
import AdminGate from "@/components/admin/AdminGate";

const API = `/api`;

function App() {
  const [activeEvent, setActiveEvent] = useState(null);

  useEffect(() => {
    fetch(`${API}/events/active`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data) {
          setActiveEvent(data);
          applyBrandColor(data.color);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <ActiveEventContext.Provider value={activeEvent}>
      <div className="min-h-screen bg-[#FAFAFA]">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/in" element={<CheckIn />} />
            <Route path="/out" element={<CheckOut />} />
            <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </ActiveEventContext.Provider>
  );
}

export default App;
